<template>
    <div>
            <div id="viewer"></div>      
    </div>
</template>

<script>

export default {
    methods: {
        goback() {
            this.$router.go(-1)
        },

    },
    name: 'app',
    data() {
        return {
            params: JSON.parse(this.$route.query.data)
        }
    },
    mounted: async function () {
        //console.log( window.Stimulsoft)
        //  window.Stimulsoft.Base.StiLicense.loadFromFile('license.key')
        // window.Stimulsoft.Base.StiLicense.loadFromFile("license.key");
        // console.log('Loading Viewer view');

        // console.log('Creating the report viewer with default options');
        var viewer = new window.Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false);

        // console.log('Creating a new report instance');

        var report = new window.Stimulsoft.Report.StiReport();

        report.loadFile('/reports/' + this.$route.params.reportname);

        var dataSet = new window.Stimulsoft.System.Data.DataSet("dataset");
        // var param= "?fromdate="+this.params.fromdate+"&todate="+this.params.todate+"&branch_id="+this.params.branch_id
        // var param=new  URLSearchParams(this.params).toString
        //    console.log('Cover obj to params: '+ param);
         // report.setVariable('caption', this.params.caption);


   //     let param = "school_id=" + this.params.school_id + "&fromdate=" + this.params.fromdate+ "&todate=" + this.params.todate
   var param="";
   for (const [key1, value1] of Object.entries(this.params)) {
         //   report.setVariable(key, value);
        //    console.log(`${key}: ${value}`);
        param =param+`${key1}=${value1}&`
        }
        let apiUrl = this.$store.getters.getBaseUrl +'/'+this.$route.params.apiname+'?' + param;
        dataSet.readJsonFile(apiUrl, this.params);//one JSON object

        //this line of code added,too.
        report.dictionary.databases.clear();
        report.regData("dataset", "dataset", dataSet);

        for (const [key, value] of Object.entries(this.params)) {
            report.setVariable(key, value);
            console.log(`${key}: ${value}`);
        }

        // ຍອດຍົກມາ: ດຶງໂດຍກົງແລ້ວຕັ້ງເປັນ Report Variable
        // (Sum() ຂ້າມ data source ພາຍໃນ Title/Header band ບໍ່ໜ້າເຊື່ອຖືເມື່ອ items ວ່າງເປົ່າ)
        try {
            const res = await fetch(apiUrl);
            const body = await res.json();
            const opening = (body.opening && body.opening[0] && body.opening[0].balance) || 0;
            report.setVariable('openingBalance', opening);
        } catch (e) {
            report.setVariable('openingBalance', 0);
        }

        //this line of code is also required.
        report.dictionary.synchronize();

        //  console.log('Assigning report to the viewer, the report will be built automatically after rendering the viewer');
        viewer.report = report;

        // console.log('Rendering the viewer to selected element');
        viewer.renderHtml('viewer');

        //  console.log('Loading completed successfully!');

    }
}
</script>

<style>
</style>
